var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardDeviceStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck-bolt-light 1",
    clipPath: "url(#clip0_1041_3245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.12 1.97321C22.182 1.97321 23.04 2.85499 23.04 3.94643V23.6786H15.03C14.238 21.3785 12.108 19.7321 9.6 19.7321C7.092 19.7321 4.956 21.3785 4.17 23.6786H3.84C2.778 23.6786 1.92 22.7968 1.92 21.7054V3.94643C1.92 2.85499 2.778 1.97321 3.84 1.97321H21.12ZM0 21.7054C0 23.8821 1.722 25.6518 3.84 25.6518C3.84 28.9199 6.42 31.5714 9.6 31.5714C12.78 31.5714 15.36 28.9199 15.36 25.6518H23.04C23.04 28.9199 25.62 31.5714 28.8 31.5714C31.98 31.5714 34.56 28.9199 34.56 25.6518H37.44C37.968 25.6518 38.4 25.2078 38.4 24.6652C38.4 24.1225 37.968 23.6786 37.44 23.6786H36.48V14.5401C36.48 13.831 36.234 13.1527 35.784 12.6162L31.062 6.95558C30.516 6.29579 29.718 5.91964 28.878 5.91964H24.96V3.94643C24.96 1.76973 23.238 0 21.12 0H3.84C1.722 0 0 1.76973 0 3.94643V21.7054ZM24.96 7.89286H28.878C29.16 7.89286 29.424 8.01618 29.604 8.23817L34.254 13.8125H24.96V7.89286ZM24.96 21.2367V15.7857H34.56V23.6786H34.23C33.438 21.3785 31.308 19.7321 28.8 19.7321C27.324 19.7321 25.98 20.2994 24.96 21.2367ZM9.6 21.7054C11.718 21.7054 13.44 23.4751 13.44 25.6518C13.44 27.8285 11.718 29.5982 9.6 29.5982C7.482 29.5982 5.76 27.8285 5.76 25.6518C5.76 23.4751 7.482 21.7054 9.6 21.7054ZM24.96 25.6518C24.96 23.4751 26.682 21.7054 28.8 21.7054C30.918 21.7054 32.64 23.4751 32.64 25.6518C32.64 27.8285 30.918 29.5982 28.8 29.5982C26.682 29.5982 24.96 27.8285 24.96 25.6518Z",
    fill: "#ED7200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_3245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 31.5714,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDeviceStatus);
export default __webpack_public_path__ + "static/media/dashboard-device-status.5c42392c0fbf1d3be2d3f473cc9d30c7.svg";
export { ForwardRef as ReactComponent };